import {
  Form,
  Button,
  Row,
  Col,
  Checkbox,
  Descriptions,
  Typography
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomDropDown from "../customDropDown/customDropDown";
import {
  useForm,
} from "react-hook-form";
import {
  DatePickerField,
  Dependency,
  DropdownField,
  Field,
  FileUploadField,
  RadioField,
  TextField,
  TextAreafield,
  CascadeDropdownField,
  DenominationField,
  ApiValues,
  SearchableField,
} from "../../types/field";
import CustomDatePicker from "../datePicker/datepicker";
import { InputComponent } from "../input/inputuncontrolled";
import {
  filterNullValues,
  getIndexOfAccessLevel,
  getIndexOfAccessLevelFromVal,
  getIndexOfPlatformAction,
  getIndexOfPlatformActionFromVal,
} from "../../utils/utils";
import { AccessLevel, DenominationOptionValues, RowLevelAction } from "../../types/types";
import CustomFileUpload from "../fileupload/fileupload";
import { Notification } from "../notification/notification";
import TextAreaInput from "../textArea/textArea";
import CascadeDropDown from "../customDropDown/cascadeDropDown";
import CustomRecordDetailModal from "../modal/customRecordDetailModal";
import Denomination from "../denomination/denomination";
import { CloseCircleOutlined } from "@ant-design/icons";
import { apiAliasMapper, filterNonCreatableFields, filterNonUpdatableFields, getApiForField, handleLoanNumberLookUp, handleOnBlurOnField, isFieldEditable, isMandatoryField, mapCreateApiToAliasNames, mapViewApiToAliasNames } from "./recordDetailUtils";
import CustomDateTimePicker from "../dataAndTimePicker/datetimepicker";
import { SearchableInputComponent } from "../searchableInputComponent/searchableInputComponent";
import { AdressInputComponent } from "../addressInputComponent/addressInputComponent";
import { GetRequest, PostRequest, PutRequest } from "../../utils/api";
import { aadhaarPattern, passportRegex, licenseRegex, rationCardRegex, mobileRegex, panRegex, emailRegex, voterIdRegex } from "../../utils/regex-patterns";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { reloadDetailsPage } from "../../states/actions";
import { refineApiWithUrlParams } from "./detailsPageCommonsUtils";
import CustomIcon from "../icons/CustomIcon";
import CommonRadioGroup from "../CommonRadioGroup/CommonRadioGroup";
import moment from "moment";
import { getRegexForValidation } from "../../utils/getRegexForValidation";
import { renderSubHeading } from "./detailsPagesUtils";

const { Text } = Typography;
interface Props {
  urlparams: Map<string, string>;
  recordId: string;
  platformAction: RowLevelAction;
  createApi: string;
  dataApi: string;
  dataApiMapper?: apiAliasMapper[];
  createApiMapper?: apiAliasMapper[];
  viewApi?: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  editForm: Field[];
  setOpen: Function;
  dependantFields?: Dependency;
  userAccessLevel: AccessLevel;
  parentEntity?: string;
  recordIds?: any[];
  refreshTable?: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  moduleCode: string;
  viewPageBluPrint: any;
}

const PaymentRecordDetails: React.FC<Props> = ({
  recordId,
  editForm,
  dataApi,
  viewApi = dataApi,
  createApi,
  isCreateFlow,
  isRelatedInfo,
  setOpen,
  dependantFields,
  userAccessLevel,
  platformAction,
  parentEntity = undefined,
  urlparams,
  recordIds,
  refreshTable = () => { },
  allowEdits,
  selectedRows,
  moduleCode,
  viewPageBluPrint,
  dataApiMapper,
  createApiMapper,
}) => {
  const [formSchema, setFormSchema] = useState<Field[]>([]);
  const [dynamicFieldCounter, setDynamicFieldCounter] = useState<number>(1);
  const [receivedDenominationOptions, setReceivedDenominationOptions] = useState<DenominationOptionValues[]>([]);
  const [returnedDenominationOptions, setReturnedDenominationOptions] = useState<DenominationOptionValues[]>([]);
  const [amountNotEqual, setAmountNotEqual] = useState<boolean>(false);
  const [amountToBeReturned, setAmountToBeReturned] = useState<number>(0);
  const [duplicateCollectionNature, setDuplicateCollectionNature] = useState<boolean>(false);
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [viewData, setViewData] = useState<any>({});
  const [optionValueList, setOptionValueList] = useState([]);
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const {
    control
  } = useForm<any>({});

  const resetField = (field: string) => {
    const temp = {
      [field]: undefined
    }
    form.setFieldsValue(temp);
  }

  const setError = (field: string, error: any) => {
    form.setFields([
      {
        name: field, // Field name
        errors: [error.message], // Array of error messages
      }
    ]);
  }

  const [form] = Form.useForm();

  useEffect(() => {
    if (getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)) {
      setIsEditClicked(true);
    }
  }, [platformAction]);

  const getViewData = (endpoint: string) => {

    if (endpoint?.length > 0) {

      endpoint = refineApiWithUrlParams(endpoint, urlparams);

      GetRequest(endpoint).then((data) => {
        setViewData(mapViewApiToAliasNames(data, dataApiMapper));
        form.setFieldsValue(mapViewApiToAliasNames(data, dataApiMapper));
      });
    }

    getFormSchema();

  };

  // reconverted to redux as this is dependant on table
  const CreateNewRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {
    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PostRequest(endpoint, data, moduleCode);

        Notification("success", "Saved Successfully");
        setSaveLoading(false);
        refreshTable();
        setOpen(false);
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };
  // reconverted to redux as this is dependant on table
  const UpdateRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {
    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PutRequest(endpoint, filterNonUpdatableFields(data, formSchema), moduleCode);

        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);
        setOpen(false);
        setIsEditClicked(false);
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }
  };

  const filterReadOnlyFields: any = (data: any) => {
    let editPayload: any = { ...data };
    let readOnlyFields = formSchema
      .filter((x) => !x.editable && x.fieldType !== 'formula')
      .map(({ field }) => field);
    Object.keys(data).forEach((key, index) => {
      if (readOnlyFields.includes(key)) {
        delete editPayload[key];
      }
    });
    return editPayload;
  };

  const onSubmit = (data: any) => {

    data = filterNullValues(data);


    if (data.infoTypeId) {
      if (data.infoTypeId === "1" && !aadhaarPattern.test(data.newValue)) {
        Notification("error", "please enter valied aadhar card value");
        return true;
      } else if (data.infoTypeId === "2" && !voterIdRegex.test(data.newValue)) {
        Notification("error", "please enter valied voter id card value");
        return true;
      } else if (
        data.infoTypeId === "3" &&
        !passportRegex.test(data.newValue)
      ) {
        Notification("error", "please enter valied passport value");
        return true;
      } else if (data.infoTypeId === "6" && !licenseRegex.test(data.newValue)) {
        Notification("error", "please enter valied license value");
        return true;
      } else if (
        data.infoTypeId === "7" &&
        !rationCardRegex.test(data.newValue)
      ) {
        Notification("error", "please enter valied rationCard value");
        return true;
      } else if (data.infoTypeId === "8" && !mobileRegex.test(data.newValue)) {
        Notification("error", "please enter valied mobile value");
        return true;
      } else if (data.infoTypeId === "10" && !panRegex.test(data.newValue)) {
        Notification("error", "please enter valied PAN value");
        return true;
      } else if (data.infoTypeId === "11" && !emailRegex.test(data.newValue)) {
        Notification("error", "please enter valied email value");
        return true;
      }
    }
    // remove readonly fields in case of edit form
    if (!isCreateFlowRequired()) {
      data = filterReadOnlyFields(data);
    } else {
      data = filterNonCreatableFields(data, formSchema);
    }

    data = mapCreateApiToAliasNames(data, viewData, urlparams, createApiMapper);
    //tranform the data to match composite json payload based on field type
    let multiValueField = formSchema.filter((field) => field.iterate)[0];

    if (
      multiValueField !== undefined &&
      multiValueField.fieldType === "fileUpload"
    ) {
      let childEntities = formSchema
        .filter(
          (field) => field.childEntity && field.fieldType === "fileUpload"
        )
        .map((f) => {
          return { chilldEntity: f.childEntity, field: f.field };
        });

      childEntities.forEach(({ chilldEntity, field }) => {
        if (!data[chilldEntity!]) {
          data[chilldEntity!] = data[field];
          delete data[field];
        }

      });
    }

    let fieldCollection: Field[];
    if (
      multiValueField !== undefined &&
      multiValueField.fieldType === "dropDown"
    ) {
      if (
        createApi ===
        "payments/composite/platform/{version}/api/composite/payment-collection-composition"
      ) {
        fieldCollection = [...editForm];
      } else {
        fieldCollection = [...formSchema];
      }
      fieldCollection = [...formSchema];
      let childEntities = fieldCollection
        .filter((field) => field.childEntity)
        .map((f) => {
          return { chilldEntity: f.childEntity, field: f.field };
        });

      // find unique childs
      let childs = fieldCollection
        .filter((field) => field.childEntity)
        .map((f) => {
          return f.childEntity;
        });
      let uniqueChilds = [...new Set(childs)];

      let multiValues: string = data[multiValueField.field];
      // handle multiple child entities..
      uniqueChilds.forEach((child) => {
        let childItems: any = [];
        multiValues.split(",").forEach((value) => {
          let item: any = {};
          if (multiValueField.childEntity === child) {
            item[multiValueField.field] = value;
          }

          childEntities.forEach(({ chilldEntity, field }) => {
            if (!item[field] && child === chilldEntity) {
              item[field] = data[field];
            }
          });
          childItems.push(item);
        });
        data[child!] = [...childItems];
      });

      // process error validation
      let totalAmount = Number(data["receiptAmount"]);
      let paymentNature = data["paymentNature"][0];
      let paymentNatureData: Array<any> = [];
      let paymentNatureCodes: Set<string> = new Set();
      let isDuplicateCollectionNatureExists = false;
      //paymentNature.forEach((element) => {});
      let count: number = 0;
      let x: any = {};
      Object.keys(paymentNature).forEach((key, index) => {
        if (index % 2 === 0) {
          x["receiptNatureCode"] = paymentNature[key];
          if (paymentNatureCodes.has(paymentNature[key])) {
            isDuplicateCollectionNatureExists = true;
          }
          paymentNatureCodes.add(paymentNature[key]);
        } else {
          x["receiptNatureAmount"] = paymentNature[key];
          count = count + Number(paymentNature[key]);
          paymentNatureData.push(x);
          x = {};
        }
      });
      if (isDuplicateCollectionNatureExists) {
        setDuplicateCollectionNature(true);
        return;
      }
      setDuplicateCollectionNature(false);
      if (count !== totalAmount) {
        setAmountNotEqual(true);
        return;
      }

      let recivedDenom = Number(data["totalReceivedAmount"]);
      let returnedDenom = 0;
      if (data["totalReturnedAmount"]) {
        returnedDenom = Number(data["totalReturnedAmount"]);
      }

      if (data["paymentMode"] === 'C') {
        if (totalAmount !== recivedDenom - returnedDenom) {

          setError(
            "receiptAmount",
            {
              type: "focus",
              message: "Total amount should match with denomination",
            }
          );
          return;
        }
      }

      delete data["paymentNature"];
      data["paymentNature"] = paymentNatureData;

      childEntities.forEach(({ chilldEntity, field }) => {
        delete data[field];
      });
    }
    //this is to pass unique ids as a part of payload
    if (recordIds && recordIds.length > 0) {
      data["recordIds"] = recordIds;
    }

    if (parentEntity) {
      let f: any = {};
      f[parentEntity] = [{ ...data }];
      data = f;
    }

    if (isCreateFlowRequired()) {
      CreateNewRecord(createApi, recordId, data);
    } else {
      UpdateRecord(dataApi, recordId, data);
    }
  };

  const isCreateFlowRequired = (): boolean => {
    return (
      isCreateFlow ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.TRANSFER) ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)
    );
  };

  useEffect(() => {
    if (
      viewApi?.length > 0 &&
      (!isCreateFlow ||
        getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT) ||
        isRelatedInfo)
    ) {
      getViewData(viewApi);
    }
  }, [viewApi, recordId]);

  //TODO: this is a temporary fix need to find a proper way to add grouped fields
  const addGroupFieldBehaviour = () => {
    let editFields = [...formSchema];
    const receiptNatureCodeIndx = editFields.findIndex(obj => obj.field === "receiptNatureCode");
    const receiptNatureAmountIndx = editFields.findIndex(obj => obj.field === "receiptNatureAmount");
    if (
      createApi !==
      "payments/composite/platform/{version}/api/payment-collection-composition"
    ) {
      return;
    }

    let receiptNatureCode = editFields.find(
      (field) => field.field === "receiptNatureCode"
    );

    let receiptNatureAmount = editFields.find(
      (field) => field.field === "receiptNatureAmount"
    );

    let receiptNatureCodeClone = { ...receiptNatureCode } as Field;
    receiptNatureCodeClone.isGroupedField = true;

    let receiptNatureCodeClone1 = { ...receiptNatureCode } as Field;
    receiptNatureCodeClone1.isGroupedField = true;
    receiptNatureCodeClone1!.field = `${receiptNatureCodeClone1?.field}${dynamicFieldCounter}`;

    let receiptNatureAmountClone = { ...receiptNatureAmount } as Field;
    receiptNatureAmountClone.isGroupedField = true;
    let receiptNatureAmountClone1 = { ...receiptNatureAmount } as Field;
    receiptNatureAmountClone1.isGroupedField = true;
    receiptNatureAmountClone1!.field = `${receiptNatureAmountClone1?.field}${dynamicFieldCounter}`;

    let tempForm: Array<Field> = [];

    tempForm = tempForm.concat();
    tempForm = [
      ...editFields
        .filter((field) => field.field !== "receiptNatureAmount")
        .filter((field) => field.field !== "receiptNatureCode"),
    ];

    tempForm.splice(receiptNatureCodeIndx, 0, receiptNatureCodeClone);
    tempForm.splice(receiptNatureAmountIndx, 0, receiptNatureAmountClone);
    tempForm.splice(receiptNatureCodeIndx + 2 * dynamicFieldCounter, 0, receiptNatureCodeClone1);
    tempForm.splice(receiptNatureAmountIndx + 2 * dynamicFieldCounter, 0, receiptNatureAmountClone1);

    setFormSchema(tempForm);
    setDynamicFieldCounter(dynamicFieldCounter + 1);
    //return tempForm;
  };

  const getFormSchema = useCallback(() => {
    setFormSchema([...refreshFieldsBasedOnVisibility()]);
  }, [editForm]);

  const fillUpWithFieldValues = (criteria: string): string => {
    let response = criteria;

    const vals = form.getFieldsValue();
    editForm.forEach((field: Field) => {
      response = response.replaceAll("field." + field.field + " ", "'" + vals[field.field] + "'");
    });

    return response;
  }

  const getExtraFieldsFromOriginalForm = (): Field[] => {
    let fields: Field[] = [];
    let formSchemaKeys = new Set<string>();
    formSchema.forEach(field => {
      formSchemaKeys.add(field.field);
    });

    editForm.forEach(field => {
      if (!formSchemaKeys.has(field.field)) {
        fields.push(field);
      }
    });
    return fields;
  }

  const schemaFieldsExcludingDenomination = (): Field[] => {
    return formSchema.filter(field => (field.field !== 'returnedDenom' && field.field !== 'receivedDenom'));
  }

  const refreshFieldsBasedOnVisibility = (): Field[] => {
    let tempForm: Field[] = [];
    if (editForm) {
      let allFields: Field[] = [...schemaFieldsExcludingDenomination(), ...getExtraFieldsFromOriginalForm()];

      allFields.forEach((field: Field) => {
        let criteria = field.visibilityCriteria ?? "true";
        criteria = fillUpWithFieldValues(criteria);
        if (eval(criteria)) {
          let f = { ...field };
          tempForm.push(f);
        } else {
          resetField(field.field);
        }
      });
    }
    return tempForm;
  }

  const navigateToModule = (detailsObject: any) => {

    let fieldsToRemember: any = {
      action: detailsObject.action,
      dataApi: detailsObject.dataAPI,
      recordId: detailsObject.recordId,
      toURL: detailsObject.toURL
    };

    detailsObject.fieldsToRemember.forEach((item: string) => {
      fieldsToRemember[item] = viewData[item]
    });

    dispatch(reloadDetailsPage(fieldsToRemember));
  };

  const valueStore = useRef<any>();

  useEffect(() => {
    if (valueStore.current) {
      form.setFieldsValue(valueStore.current);
    }
  }, [formSchema]);

  const handleOnChange = (value: string, field: string, isCheckBox: boolean = false) => {

    // if (!isCheckBox) {
    //   if (!value || (Array.isArray(value) && value.length === 0)) {
    //     return;
    //   }
    // }

    let temp: any = formSchema.find((item: any) => item.field === field);

    //If a expected value is configured in blueprint - navigate accordingly
    if (temp && temp.expectedValue && value === temp.expectedValue) {
      navigateToModule(temp);
    }

    //Need to store this in ref variable to rerender after formSchema is updated
    const fieldsVals = form.getFieldsValue(true);
    fieldsVals[field] = value;

    if (value === '001' && field === "custRelation" && form.getFieldValue('payerType') === '001') {


      fieldsVals["paymentFrom"] = form.getFieldValue('customerName');

      setViewData({
        ...viewData,
        paymentFrom: form.getFieldValue('customerName')
      });

    };

    form.setFieldsValue(fieldsVals);

    valueStore.current = fieldsVals;

    let fields = [...refreshFieldsBasedOnVisibility()];

    setFormSchema([...fields, ...getDenominationFieldsIfApplicable()]);
    form.validateFields([field]);

  };

  useEffect(() => {
    computTotalAmountToReturn();
  }, [form.getFieldsValue()["receiptAmount"], form.getFieldsValue()["totalReceivedAmount"], form.getFieldsValue()["totalReturnedAmount"]]);

  const computTotalAmountToReturn = () => {

    const vals = form.getFieldsValue();

    const totalReceivedAmount = isNaN(parseInt(vals["totalReceivedAmount"])) ? 0 : parseInt(vals["totalReceivedAmount"]);

    const totalAmount = isNaN(parseInt(vals["receiptAmount"])) ? 0 : parseInt(vals["receiptAmount"]);

    const totalRetunedAmount = isNaN(parseInt(vals["totalReturnedAmount"])) ? 0 : parseInt(vals["totalReturnedAmount"]);

    setAmountToBeReturned(totalReceivedAmount - totalAmount - totalRetunedAmount);

  };


  const getDenominationFieldsIfApplicable = (): Field[] => {
    let response: DenominationField[] = [];
    const vals = form.getFieldsValue();
    editForm.forEach((field: Field) => {
      if (vals[field.field] === "C" && field.field === "paymentMode") {
        // create dropdown payload
        // field type as DenominationDropDown
        // add to formarray
        let field: DenominationField = {
          isGroupedField: false,
          order: 0,
          childEntity: "",
          showOnlyInCreate: false,
          iterate: false,
          fieldType: "denomination",
          field: "receivedDenom",
          displayName: "Recieved Denomination",
          toolTip: "",
          editable: true,
          api: "",
          rules: [],
          optionList: [500, 200, 100, 50, 20, 10, 5, 2, 1].map(value => ({
            name: value,
            code: ""
          })),
          placeholder: "Select Amount",
          selectedOptions: receivedDenominationOptions,
          setSelectedDenominationOptions: setReceivedDenominationOptions
        };

        let field1: DenominationField = {
          isGroupedField: false,
          order: 0,
          childEntity: "",
          showOnlyInCreate: false,
          iterate: false,
          fieldType: "denomination",
          field: "returnedDenom",
          displayName: "Returned Denomination",
          toolTip: "",
          editable: true,
          api: "",
          rules: [],
          optionList: [200, 100, 50, 20, 10, 5, 2, 1].map(value => ({
            name: value,
            code: ""
          })),
          placeholder: "Select Amount",
          selectedOptions: returnedDenominationOptions,
          setSelectedDenominationOptions: setReturnedDenominationOptions
        };

        response = [field, field1];
      }
    });

    return response;
  };

  const handleCascadeOnChange = (value: string, field: string) => {
    // TODO: doesnt work in internet explorer need polyfill
    // api url for cascade fields will be empty handled at client side.
    let indexOfFieldToRefresh = formSchema.findIndex(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    // fetch field from editform as this has the api urls for the cascade fields
    let fieldData = editForm.find(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    if (
      indexOfFieldToRefresh === -1 ||
      fieldData === null ||
      fieldData === undefined
    ) {
      return;
    }

    let fieldToRefresh = { ...formSchema[indexOfFieldToRefresh] };

    // modify api query params based on selection
    let api = fieldData.api;
    let apiWithQueryParams = `${api}&search=${field}:in${value}`;
    fieldToRefresh.api = apiWithQueryParams;

    if (viewData[fieldToRefresh.field]) {
      delete viewData[fieldToRefresh.field];
    }

    if (urlparams.has(fieldToRefresh.field)) {
      urlparams.set(fieldToRefresh.field, "");
    }

    // update field at certain index
    const newFormSchema = [...formSchema];
    newFormSchema[indexOfFieldToRefresh] = fieldToRefresh;

    // update state with new formfields
    setFormSchema(newFormSchema);
    resetField(fieldToRefresh.field);
  };

  const handleOnBlur = async (
    value: any,
    field: string,
    lookupField?: string,
    lookupFieldUrl?: string
  ) => {

    if (!lookupField || !lookupFieldUrl || value === "") {
      return;
    }

    handleLoanNumberLookUp(value, lookupField, lookupFieldUrl)
      .then((customerName: any) => {
        handleOnChange(customerName, lookupField);
      })
      .catch((error) => {
        form.setFields([
          {
            "errors": ["Invalid Loan Number"],
            "name": field,
          }
        ])
      });
  };

  // Start of Form Fields render methods
  // Below methods should be same in all record details pages - If any change is made - copy the whole to other record details page
  const renderTextBox = (field: TextField) => {
    return field.field === "receiptNatureAmount"
      ? renderTextBoxWithButton(field)
      : renderPlainTextBox(field);
  };

  const renderTextAreainput = (field: TextField) => {

    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
              message: "Please enter the value.",
            },
          ]}
        >
          <TextAreaInput
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={form.setFieldValue}
            placeholder={field?.placeholder}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            rules={field?.rules && field?.rules[0]}
            maxLength={field?.rules[0].maxSize}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderPlainTextBox = (field: TextField, span = 12) => {

    //DND - Needed for expressions in blueprint
    const currentDate = moment();

    return (
      <Col span={24} lg={span}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}
            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? getRegexForValidation(field?.rules[0]?.allowValues).value : undefined,
                message: "Please enter valid value.",
              }
            ]}
          >

            <InputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={form.setFieldValue}
              placeholder={field?.placeholder}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onBlur={(val: any) => {

                handleOnChange(val, field?.field);

                if (field.lookupField && field.lookupFieldEndpoint) {
                  handleOnBlur(val, field.field, field.lookupField, field.lookupFieldEndpoint)
                }
              }
              }
              rules={field?.rules && field?.rules[0]}
              icon={field.icon}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderAddressField = (field: TextField) => {
    return (
      <Col span={24} lg={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}

            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                message: "Please enter valid value.",
              },
            ]}
          >
            <AdressInputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={form.setFieldValue}
              placeholder={field?.placeholder}
              recordId={refineApiWithUrlParams("{loanNo}", urlparams)}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(val: any) => handleOnChange(val, field?.field)}
              rules={field?.rules && field?.rules[0]}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderSearchableInputField = (field: SearchableField) => {

    return (
      <Col span={24} lg={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}

            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                message: "Please enter valid value.",
              },
            ]}
          >
            <SearchableInputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={form.setFieldValue}
              placeholder={field?.placeholder}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(val: any) => handleOnChange(val, field?.field)}
              rules={field?.rules && field?.rules[0]}
              searchModalProps={field.searchModalProps}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderTextBoxWithButton = (field: TextField) => {

    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
              message: "Please enter the value.",
            },
          ]}
        >
          <InputComponent
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={form.setFieldValue}
            placeholder={field?.placeholder}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            onChange={(val: any) => handleOnChange(val, field?.field)}
            rules={field?.rules && field?.rules[0]}
          />
          <Button type="text" danger onClick={() => addGroupFieldBehaviour()}>
            Add
          </Button>
        </Form.Item>
      </Col>
    );
  };

  const renderDropDown = (field: DropdownField, span = 12) => {

    const apiValue: ApiValues = getApiForField(editForm, form.getFieldsValue, field);
    return (
      <Col span={24} lg={span}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory ? true : false,
              message: "Please select the value.",
            },
          ]}
        >
          <div className="dropdown-custom">
            <CustomDropDown
              name={field?.field}
              title={field?.displayName}
              control={control}
              setValue={form.setFieldValue}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(e: any) => {

                console.log(e);
                handleOnChange(e, field?.field);

                if (field.actions && field.actions.length > 0) {
                  handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
                }

              }}
              api={refineApiWithUrlParams(apiValue.api, urlparams)}
              rules={field?.rules[0]}
              dropdownCode={apiValue.dropdownCode}
              dropdownValue={apiValue.dropdownValue}
              placeholder={field?.placeholder}
              showOnlyValue={field?.rules[0].showOnlyValue}
              value={form.getFieldValue(field.field)}
              data={form.getFieldValue(field.field)}
              staticDropDownValues={field.staticDropDownValues ?? []}
              setOptionValueList={setOptionValueList}
              // showOnlyValue={field?.rules[0].showOnlyValue}
              optionValueList={optionValueList}
              disabledOption={[]}
            />
          </div>
        </Form.Item>
      </Col>
    );
  };

  const renderCascadeDropDown = (field: CascadeDropdownField) => {
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          rules={[
            {
              required: field.rules[0].mandatory ? true : false,
              message: "Please select the value.",
            }
          ]}
        >
          <div className="dropdown">
            <CascadeDropDown
              name={field?.field}
              title={field?.displayName}
              control={control}
              setValue={form.setFieldValue}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(val: any) => {
                handleOnChange(val, field.field);

                handleCascadeOnChange(val, field?.field);

                if (field.actions && field.actions.length > 0) {
                  handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
                }


              }}
              api={refineApiWithUrlParams(field.api ?? "", urlparams)}
              rules={field?.rules[0]}
              dropdownCode={field?.dropdownCode}
              dropdownValue={field?.dropdownValue}
              placeholder={field?.placeholder}
              isCascade={
                field.valuesDependOnField !== undefined &&
                field.valuesDependOnField !== null &&
                field.valuesDependOnField !== ""
              }
              showOnlyValue={field?.rules[0]?.showOnlyValue}
              parentFieldValues={viewData}
              parentFieldName={field?.valuesDependOnField}
            />
          </div>

        </Form.Item>
      </Col>
    );
  };

  const renderCalender = (field: DatePickerField) => {
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomDatePicker
            title={field?.displayName}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}
            onChange={(e: any) => handleOnChange(e, field.field)}
            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={form.setFieldValue}
            name={field.field}
            id={field.field}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderCalenderWithTime = (field: any) => {
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomDateTimePicker
            title={field?.displayName}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}
            onChange={(e: any) => handleOnChange(e, field.field)}
            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={form.setFieldValue}
            name={field.field}
            id={field.field}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderFileUpload = (field: any) => {

    var rules = { ...field.rules[0] };

    return (
      <>
        <Col span={24} lg={12} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}
            rules={[
              {
                required: rules.mandatory,
                message: "Please select a File",
              }
            ]}
          >
            <CustomFileUpload
              width={200}
              title={field?.displayName}
              data={field.childEntity ? form.getFieldValue(field.childEntity) : form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(files: any) => {
                if (field.childEntity) {
                  form.setFieldValue(field.childEntity, files);
                } else {
                  form.setFieldValue(field.field, files[0].fileName);
                }
              }
              }
              rules={rules}
              placeholder={field?.placeholder}
              control={control}
              setValue={form.setFieldValue}
              uploadApi={field.api}
              maxFilesAllowed={field.rules[0].maxFilesAllowed}
              downloadApi={field.downloadApi}
              name={field.field}
              id={field.field}
              childEntity={field.childEntity}
              getValue={form.getFieldsValue}
            />
          </Form.Item>
        </Col>
      </>
    );
  };

  const renderRadio = (field: RadioField) => {
    return (
      <Col span={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CommonRadioGroup
            title={t(field?.displayName)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            rules={field?.rules[0]}
            api={field.api ?? ""}
            placeholder={field?.placeholder}
            onChange={(e: any) => {
              handleOnChange(e, field?.field)
            }
            }
            control={control}
            setValue={form.setFieldValue}
            name={field.field}
            options={field.values}
            data={form.getFieldValue(field.field)}
            uiType={field.uiType}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderCheckBox = (field: any) => {
    return (
      <Col span={12} >
        <Form.Item
          className="mx-1"
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <Checkbox
            type={"checkbox"}
            checked={form.getFieldValue(field.field)}
            defaultChecked={form.getFieldValue(field.field)}
            onChange={(e: any) => {

              handleOnChange(e.target?.checked, field?.field, true);

            }}
            name={field.field}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
          >
            <label className="font-medium"> {t(field?.displayName)} </label>
          </Checkbox>
        </Form.Item>
      </Col>
    );
  };

  // End of form fields render methods

  // TODO: use enum instead of strings
  const renderField = (field: Field) => {

    if (field.display === false) {
      return;
    }

    if (selectCheckBox && (form.getFieldsValue()?.[field?.field] == '' || form.getFieldsValue()?.[field?.field] == undefined)) {
      return;
    }

    if (field?.rules && field?.rules[0]) {
      field.rules[0].mandatory = isMandatoryField(field, form.getFieldsValue, editForm);
    }

    switch (field.fieldType) {
      case "textBox":
        return renderTextBox(field as TextField);
      case "textArea":
        return renderTextAreainput(field as TextAreafield);
      case "address":
        return renderAddressField(field as TextField);
      case "searchableField":
        return renderSearchableInputField(field as SearchableField);
      case "dropDown":
        return renderDropDown(field as DropdownField);
      case "cascadeDropDown":
        return renderCascadeDropDown(field as CascadeDropdownField);
      case "calendar":
        return renderCalender(field as DatePickerField);
      case "radio":
        return renderRadio(field as RadioField);
      case "checkBox":
        return renderCheckBox(field as any);
      case "fileUpload":
        return renderFileUpload(field as FileUploadField);
      case "subHeading":
        return renderSubHeading(field as any)
      case "calendarWithTime":
        return renderCalenderWithTime(field as any)
    }
  };

  const renderActions = () =>
    formSchema?.map((field: Field) => {
      switch (field.fieldType) {
        case "actionButton":
          return field.actionInfo?.type === "modal" ? (
            <CustomRecordDetailModal
              viewPageBluPrint={viewPageBluPrint}
              title={field.actionInfo?.title ?? ""}
              platformAction={field.actionInfo?.launchMode}
              blueprintApi={field.actionInfo?.blueprintApi ?? ""}
              actionName={field.displayName}
              isCreateFlow={field.actionInfo?.launchMode === "Create" || field.actionInfo?.launchMode === "CreateWithContext"}
              userAccessLevel={userAccessLevel}
              moduleCode={moduleCode}
              allowEdits={
                field.actionInfo?.launchMode === "Create" ||
                field.actionInfo?.launchMode === "CreateWithContext" ||
                field.actionInfo?.launchMode === "Edit"
              }
              urlparams={urlparams}
            />
          ) : (
            <></>
          );
      }
    });

  const renderFields = () =>
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24, xl: 36 }} className="tabs mx-0">
      {formSchema?.filter((field: Field) => !field.field.includes("receiptNatureCode") && !field.field.includes("receiptNatureAmount")).map((field: any) =>
        renderField(field)
      )}
    </Row>

  const renderSpisSection = () => {
    return <Descriptions>{getDetails()}</Descriptions>;
  };

  const getDetails = () => selectedRows?.map((x: any) => getDetail(x));

  const getDetail = (x: any) =>
    Object.keys(x)
      .filter((key) => {
        return !(
          key === "createdBy" ||
          key === "creationDtm" ||
          key === "srno"
        );
      }).map((key) => {
        const result = key.replace(/([A-Z])/g, " $1");
        const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
        return <Descriptions.Item label={finalResult}>{x[key]}</Descriptions.Item>;
      });

  const removeCollectionBreakUp = (collectionNatureTypeField: DropdownField, collectionNatureAmount: TextField) => {

    let formData = [...formSchema];
    // unregister(collectionNatureTypeField.field);
    // unregister(collectionNatureAmount.field);
    setFormSchema(formData.filter(field => field !== collectionNatureTypeField && field !== collectionNatureAmount));
  };

  const renderCollectionBreakUpField = (collectionNatureTypeFields: DropdownField[], collectionNatureAmounts: TextField[]) => {
    return (

      <div className="my-2 w-100">
        <div>
          <div className="d-flex align-items-center mx-2">
            <div>
              <p className="subHeading text-base my-2 mx-2 font-semibold">
                {"Collection BreakUp"}
              </p>

            </div>

          </div>

          {collectionNatureTypeFields.map((collectionNatureTypeField: DropdownField, index: number) =>
            collectionNatureTypeField ? (<Row gutter={16} className="w-100 mx-2">
              <>
                {renderDropDown(collectionNatureTypeField, 11)}
              </>
              <>
                {renderPlainTextBox(collectionNatureAmounts[index], 11)}
              </>
              <Col span={2} className="text-left align-items-center">
                {index > 0 && <CloseCircleOutlined className="text-lg" style={{ verticalAlign: "bottom" }} onClick={() => removeCollectionBreakUp(collectionNatureTypeField, collectionNatureAmounts[index])} rev={undefined}></CloseCircleOutlined>}
              </Col>
            </Row>) : null)
          }
          <div className="text-center mt-2">
            <Button variant="outlined" color="primary" onClick={() => addGroupFieldBehaviour()}>
              <CustomIcon height="18" width="18" className="mr-1" name="add"></CustomIcon> Add
            </Button>
          </div>
        </div>
      </div>

    );
  };

  const renderCollectionBreakUpFields = () => {
    const collectionNatureTypeFields: Field[] = formSchema?.filter((field: Field) => field.field.includes("receiptNatureCode"))!;
    const receiptNatureAmountFields: Field[] = formSchema?.filter((field: Field) => field.field.includes("receiptNatureAmount"))!;
    return (collectionNatureTypeFields && receiptNatureAmountFields && collectionNatureTypeFields.length > 0) ? renderCollectionBreakUpField(collectionNatureTypeFields as DropdownField[], receiptNatureAmountFields as TextField[]) : null;
  };

  const renderDenominationField = (field: DenominationField) => {

    const setValue = (field: string, val: any) => {
      handleOnChange(val.toString(), field);
    }

    return (
      <Form.Item>
        <Denomination
          name={field?.field}
          title={field?.displayName}
          control={control}
          setValue={setValue}
          resetValue={resetField}
          getValues={form.getFieldsValue}
          optionList={field.optionList}
          // data={viewData[field?.field]}
          data={form.getFieldValue(field.field)}
          panelInfo={field.field === 'returnedDenom' ? <Text type="danger" className="font-semibold text-base mr-2">{"Amount to be returned: " + amountToBeReturned} </Text> : undefined}
          disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
          selectedOptions={field?.field === "receivedDenom" ? receivedDenominationOptions : returnedDenominationOptions}
          setSelectedDenominationOptions={field?.field === "receivedDenom" ? setReceivedDenominationOptions : setReturnedDenominationOptions}
        />
      </Form.Item>
    );
  };
  const renderDenomination = (field: Field) => {
    return field.fieldType === "denomination"
      ? renderDenominationField(field as DenominationField)
      : null;
  };
  const renderDenomFields = () =>
    formSchema?.map((field: Field) => renderDenomination(field));

  const createEditFields = (): any => {
    if (formSchema && formSchema.length > 0) {
      return (
        <>
          {selectedRows?.length! > 0 ? (
            <div>
              <div>
                {renderSpisSection()}
              </div>
            </div>
          ) : null}

          <Form layout="vertical" form={form} className="ant-form ant-form-vertical w-100" onFinish={onSubmit}>
            {(
              <div className="ml-3 my-2">
                {duplicateCollectionNature && <Text type="danger"> Duplicate values are not allowed in Collection Breakup.</Text>}
                {amountNotEqual && <Text type="danger">Ensure Receipt Total Amount is equal to sum of Receipt Nature Amount.</Text>}
              </div>
            )}

            <Row>{renderFields()}</Row>

            <Row className="w-100">{renderCollectionBreakUpFields()}</Row>
            {renderDenomFields()}
            {getIndexOfAccessLevel(userAccessLevel) >
              getIndexOfAccessLevelFromVal(AccessLevel.READ) && allowEdits ? (
              footer()
            ) : (
              <></>
            )}
            <div className="text-right">
              {viewPageBluPrint?.hideEmptyFeilds && (<Checkbox checked={selectCheckBox} className="px-2"
                onChange={() => setSelectCheckBox(!selectCheckBox)}>Hide Empty Field</Checkbox>)}
            </div>

          </Form>

          <>{renderActions()}</>
        </>
      );
    }
  };

  const footer = () =>
    isEditClicked || isCreateFlow ? (
      <div className="text-right mx-3 mt-2">
        <Button className="button-custom-margin" type="primary" htmlType="submit" loading={saveLoading}>
          Save
        </Button>
        <Button
          className="button-custom-margin"
          type="default"
          hidden={isCreateFlow || getIndexOfPlatformAction(platformAction) ===
            getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)}
          onClick={() => setIsEditClicked(false)}
        >
          Cancel
        </Button>
      </div>
    ) : (
      <Button type="primary" onClick={() => setIsEditClicked(true)}>
        Edit
      </Button>
    );

  return createEditFields();
};

export default PaymentRecordDetails;
